import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

/**
 * 背景：本页是纯静态构建产物，由首尔机的 Nginx 直接提供，不经 FastAPI 渲染模板。
 * 设计意图：StrictMode 打开，让副作用重复执行的问题在开发期就暴露。
 *   接 SSE 之后这一点尤其重要，订阅没清理干净会在这里表现成双份事件。
 * 关键约束：挂载点 #root 在 index.html 里，改名要两处一起改。
 */
const el = document.getElementById('root')
if (!el) throw new Error('缺少挂载点 #root，请检查 index.html')

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
